<template>
  <v-menu
    v-model="userSelectMenu"
    :close-on-content-click="false"
    :nudge-right="40"
    :nudge-top="10"
    lazy
    transition="scale-transition"
    offset-y
    full-width
    min-width="290px"
    max-height="50%"
  >
    <template v-slot:activator="{ on }">
      <v-combobox
        v-model="selectedUsers"
        chips
        clearable
        rounded
        multiple
        :label="label"
        :disabled="readOnly"
        readonly
        v-on="on"
        prepend-icon="person"
      >
        <template v-slot:selection="{ item }" v-slot:activator="{ on }">
          <v-chip :disabled="readOnly" close v-on="on" @input="remove(item)">
            <v-avatar class="primary"
              ><span class="white--text body-2">{{
                item.username
                  .toString()
                  .charAt(0)
                  .toUpperCase()
              }}</span></v-avatar
            >
            <strong>{{ item.username }}</strong>
          </v-chip>
        </template>
      </v-combobox>
    </template>
    <user-pop-up
      v-if="!readOnly"
      v-model="selectedUsers"
      :multiple="multiple"
      @input="userSelectMenu = false"
    ></user-pop-up>
  </v-menu>
</template>

<script>
import UserPopUp from '@/components/user-management/UserPopUp'

export default {
  components: {
    UserPopUp
  },
  name: 'UserAssignmentControl',
  props: {
    value: Array,
    label: String,
    multiple: {
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      selectedUsers: [],
      userSelectMenu: false
    }
  },
  mounted() {
    this.selectedUsers = this.value
  },
  watch: {
    selectedUsers() {
      this.$emit('input', this.selectedUsers)
    }
  },
  methods: {
    remove(item) {
      let index = this.selectedUsers.findIndex(i => i.hexId === item.hexId)
      if (index !== -1) this.selectedUsers.splice(index, 1)
    }
  }
}
</script>

<style scoped></style>
